import Image from "next/image";
import Head from "next/head";
import Link from "next/link";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import styles from "./upsc-environment-book.module.css";
import book from "../../assets/images/upsc/Environment-Wrapper-10th-Edition/Environment-Wrapper.jpg";
import UPSC_environment_book_Form from "./upsc-environment-book-form";
import qrscan from "../../assets/images/upsc/DuePayment/siabook-publication-2026.png";

const upsc_environmentbook = () => {

  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "UPSC Environment Book | Shankar IAS Academy",
    "description": "Explore the comprehensive UPSC Environment Book by Shankar IAS Academy. Master key concepts and stay ahead in your UPSC exam preparation.",
    "url": "https://www.shankariasacademy.com/upsc-environment-book/",
    "image":
    "https://www.shankariasacademy.com/_next/static/media/Environment-Wrapper-10th-Edition.8ca8ae34.png",
    "author": {
    "@type": "Book",
    "name": "UPSC Environment Book"
    },
    "datePublished": "January 2024",
    "publisher": {
    "@type": "EducationalOrganization",
    "name": "Shankar IAS Academy"
    }
}
 
    return (  
      <>

        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>UPSC Environment Book | Shankar IAS Academy</title>
            <meta name="title" content="UPSC Environment Book | Shankar IAS Academy" />
            <meta name="description" content="Explore the comprehensive UPSC Environment Book by Shankar IAS Academy. Master key concepts and stay ahead in your UPSC exam preparation." />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-environment-book/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="UPSC Environment Book | Shankar IAS Academy" />
            <meta property="og:description" content="Explore the comprehensive UPSC Environment Book by Shankar IAS Academy. Master key concepts and stay ahead in your UPSC exam preparation." />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-environment-book/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

        <Navbar title="upsc" />

        <div className="container">
            <div className="row">
                <div className="col pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>UPSC Environment Book</h1>
                </div>
            </div>
        </div>

        <div className="container-fluid gx-0">
            <div className={`${styles.bground}`}>
                <div className="container">
                    <div className="row py-5">
                        <div className="col-lg-2 col-12 pt-1">
                            <Image
                            src={book}
                            className="img-fluid"
                            alt="environmentbook"
                            title="Environment Book"
                            />
                        </div>
                        <div className="col-lg-6 col-8 ps-lg-5 pt-lg-0 pt-sm-3">
                            <h2 className={`${styles.sectiontitle}`}>UPSC Environment Book </h2>
                            {/* <div className={`${styles.acheivername}`}><span className={`${styles.sectiontitle}`} style={{color: "#DB1B0D"}}>&nbsp; “Out of stock”</span></div> */}
                            <div className={`${styles.acheivername}`}>CURRENT PRICE <span className={`${styles.sectiontitle}`} style={{color: "#DB1B0D"}}>&nbsp;₹ 650</span></div>
                            <p className={`${styles.acheivername} pt-2`}>Kindly Share Payment Details to the following number on WhatsApp or Write to the given mail ID</p>
                            <p className={`${styles.acheiverrank}`}>Book will be received within 7 days</p>
                            <p className={`${styles.acheivername}`}>ENVIRONMENT BOOK DISTRIBUTION</p>
                            <p className={`${styles.acheiverrank}`}>Mobile No: 9087237000 <br/>Email Id: siadistributions@shankarias.in</p>
                            <p className={`${styles.acheiverrank}`}>Email Id: siadistributions@shankarias.in</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="container">
            <div className="row py-5">
                <div className="col-lg-6 col-12 pt-1">
                    <div className="container-fluid gx-0">
                        <div className="row">
                            <div className={`${styles.section1bgbox} col p-5`}>
                                <div className={`${styles.sectionsubtitle} `}>Make Payment to buy UPSC Environment Book</div>
                                {/* <div className={`${styles.acheiverrank} pt-2`}>If you are accessing from mobile, click the 'Buy Now' button below to redirect to UPI payment app</div>
                                    <div className="my-3">
                                    <Link href="upi://pay?pa=MSSHANKARIASACADEMYBOOKPUBLICATIONS.eazypay@icici&amp;pn=M/S.SHANKAR IAS ACADEMY BOOK PUBLICATIONS&amp;tr=EZYS9361163771&amp;cu=INR&amp;am=750&amp;mc=8299"><button className={`${styles.normalbutton}`} type="submit" >Buy Now</button></Link>
                                    </div> */}
                               {/* <div className={`${styles .acheivername}`}>Scan the QR code below to make payment</div> */}
                                <Image
                                src={qrscan}
                                className="img-fluid pt-3"
                                alt="environmentQrscan"
                                title="Environment Book QR Scan"
                                /> 

                               {/* <p className="pt-4"> <span className={`${styles.sectiontitle} `} style={{color: "#DB1B0D"}}>&nbsp; “Out of stock”</span></p> */}

                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-5 col-12 pt-1">
                   <div className="container-fluid">
                      <div className="row">
                            <div className="col pt-lg-0 pt-sm-3">
                                <UPSC_environment_book_Form /> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Footer />

    </>
  )
}

export default upsc_environmentbook
